import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PropertiesPaneComponent } from './properties-pane/properties-pane.component';
import { TranslateModule } from '@ngx-translate/core';
import { NgxAngularQueryBuilderModule } from 'ngx-angular-query-builder';
import { DialogModule } from 'primeng/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { VsExcelComponent } from './vs-excel/vs-excel.component';
import { AccordionModule } from 'primeng/accordion';
import { SelectModule } from 'primeng/select';
import { InputNumberModule } from 'primeng/inputnumber';
import { PageHeaderComponent } from './page-header/page-header.component';
import { CustomReactComponent } from './custom-react/custom-react.component';
// BranchDropdownHeaderComponent is standalone - import it directly where needed
import { ViewChangesComponent } from '../pages/settings/branch-management/repo-management/view-changes/view-changes.component';
import { MergeHistoryComponent } from '../pages/settings/branch-management/repo-management/merge-history/merge-history.component';
import { FileUploadModule } from 'primeng/fileupload';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { LayoutComponent } from './layout/layout.component';
import { GridsterModule } from 'angular-gridster2';
import { ButtonModule } from 'primeng/button';
import { EditorModule } from 'primeng/editor';
import { TextareaModule } from 'primeng/textarea';
import { UIFilterPipe } from 'src/app/pipes/ui-filter.pipe';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { CheckboxGroupComponent } from './checkbox-group/checkbox-group.component';
import { CheckboxComponent } from './checkbox-group/checkbox.component';
import { IconSelectorComponent } from './icon-selector/icon-selector.component';
import { RoleLookupComponent } from './role-lookup/role-lookup.component';
import { PickupListComponent } from './pickup-list/pickup-list.component';
import { SplitButtonModule } from 'primeng/splitbutton';
import { SplitterModule } from 'primeng/splitter';
import { ProgressBarModule } from 'primeng/progressbar';
import { PickListModule } from 'primeng/picklist';
import { TooltipModule } from 'primeng/tooltip';
import { MultiSelectModule } from 'primeng/multiselect';
import { EventEditorComponent } from './event-editor/event-editor.component';
import { ChipsModule } from 'primeng/chips';
import { FontComponent } from './font/font.component';
import { ColorpickerComponent } from './colorpicker/colorpicker.component';
import { ConditionalFormatterComponent } from './conditional-formatter/conditional-formatter.component';
import { TableModule } from 'primeng/table';
import { PopoverModule } from 'primeng/popover';
import { ColorPickerModule } from 'ngx-color-picker';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { BtnActionComponent } from './btn-action/btn-action.component';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { JsonEditorComponent } from './json-editor/json-editor.component';
import { CustomMethodComponent } from './custom-method/custom-method.component';
import { OrderListModule } from 'primeng/orderlist';
import { DatePickerModule } from 'primeng/datepicker';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SizeComponent } from './size/size.component';
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { StyleEditorComponent } from './style-editor/style-editor.component';
import { MobileLayoutComponent } from './mobile-layout/mobile-layout.component';
import { TilepickerComponent } from './tilepicker/tilepicker.component';
import { CascadeSelectModule } from 'primeng/cascadeselect';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { FilteroptionsPipe } from '../pipes/filteroptions.pipe';
import { DynamicDropdownComponent } from './dynamic-dropdown/dynamic-dropdown.component';
import { WfMermaidDiagramComponent } from './wf-mermaid-diagram/wf-mermaid-diagram.component';
import { DynamicOptionsPipe } from '../pipes/dynamicOptions.pipe';
import { MailTemplateComponent } from './mail-template/mail-template.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { VsQbBuilderComponent } from './vs-qb-builder/vs-qb-builder.component';
import { FormulaBuilderComponent } from './formula-builder/formula-builder.component';
import { FontSelectorComponent } from './font-selector/font-selector.component';
import { RemoveSpacesPipe } from '../pipes/remove-spaces.pipe';
import { TimeAgoPipe } from '../pipes/time-ago.pipe';
import { TableAclComponent } from './table-acl/table-acl.component';
import { TabsModule } from 'primeng/tabs';
import { CustomDirectivesModule } from '../directives/custom-directives.module';
import { VsImportPropComponent } from './vs-import-prop/vs-import-prop.component';
import { VsForeignKeyTblComponent } from './vs-foreign-key-tbl/vs-foreign-key-tbl.component';
import { IndexDesignerComponent } from './index-designer/index-designer.component';
import { DropdownWithIndexdesignerComponent } from './dropdown-with-indexdesigner/dropdown-with-indexdesigner.component';
import { TransientFieldMappingComponent } from './transient-field-mapping/transient-field-mapping.component';
import { DefaultValCompComponent } from './default-val-comp/default-val-comp.component';
import { StaticoptionsPipe } from '../pipes/static-options.pipe';
import { VsExportPropComponent } from './vs-export-prop/vs-export-prop.component';
import { VbTextareaComponent } from './vb-textarea/vb-textarea.component';
import { VbInputTextComponent } from './vb-input-text/vb-input-text.component';
import { VbInputNumberComponent } from './vb-input-number/vb-input-number.component';
import { SearchableCtrlComponent } from './searchable-ctrl/searchable-ctrl.component';
import { ToolbarModule } from 'primeng/toolbar';
import { TreeTableModule } from 'primeng/treetable';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { BadgeModule } from 'primeng/badge';
import { ReferenceTreeViewComponent } from './reference-tree-view/reference-tree-view.component';
import { MenuModule } from 'primeng/menu';
import { Select } from 'primeng/select';
import { Menu } from 'primeng/menu';
import { BlockUIModule } from 'primeng/blockui';
import { VbBlockerComponent } from './vb-blocker/vb-blocker.component';
import { PreValidationTblViewComponent } from './pre-validation-tbl-view/pre-validation-tbl-view.component';
import { TblTypeDropdownComponent } from './tbl-type-dropdown/tbl-type-dropdown.component';
import { DecNumberComponent } from './dec-number/dec-number.component';
import { BtnBeforeActionComponent } from './btn-before-action/btn-before-action.component';
import { FilterOptionsComponent } from './filter-options/filter-options.component';
import { ConsumerappsSelectComponent } from './consumerapps-select/consumerapps-select.component';
import { LookupDefinitionComponent } from './lookup-definition/lookup-definition.component';
import { PgLookupConfigurationComponent } from './pg-lookup-configuration/pg-lookup-configuration.component';
import { QueryMappingComponent } from './query-mapping/query-mapping.component';
import { QueryTypeComponent } from './query-type/query-type.component';
import { RestConsumedAuthenticationTypeDropdownComponent } from './rest-consumed-authentication-type-dropdown/rest-consumed-authentication-type-dropdown.component';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RuntimeConfigComponent } from './runtime-config/runtime-config.component';
import { RuntimeFieldConfigDialogComponent } from './runtime-field-config-dialog/runtime-field-config-dialog.component';
import { ProviderEnvUrlConfigComponent } from './provider-env-url-config/provider-env-url-config.component';
import { CudConfigComponent } from './cud-config/cud-config.component';
import { SearchFieldSettingsComponent } from './search-field-settings/search-field-settings.component';
import { TreeSelectModule } from 'primeng/treeselect';
import { ChipModule } from 'primeng/chip';
import { TreeModule } from 'primeng/tree';
import { QueryParamMapComponent } from './query-param-map/query-param-map.component';
import { EditorWithAutocompleteComponent } from './editor-with-autocomplete/editor-with-autocomplete.component';
import { PageVariablesPropertyComponent } from './page-variables-property/page-variables-property.component';
import { SchemaToDataModelComponent } from './schema-to-data-model/schema-to-data-model.component';
import { DataModelVisualizerComponent } from './data-model-visualizer/data-model-visualizer.component';
import { SchemaPropertiesPaneComponent } from './schema-properties-pane/schema-properties-pane.component';
import { AppLoaderAnimatedComponent } from './app-loader-animated/app-loader-animated.component';
import { DeltaSqlGenerationComponent } from './delta-sql-generation/delta-sql-generation.component';
import { CarouselModule } from 'primeng/carousel';
import { DialogService } from 'primeng/dynamicdialog';
import { StaticTextComponent } from './generations-wizard/commons/static-text/static-text.component';
import { ConsoleErrorPanel } from './console-error-panel/console-error-panel.component';
import { CreateBranchTagPopupComponent } from "../pages/settings/branch-management/create-branch-tag-popup/create-branch-tag-popup.component";
import { VbButtonComponent } from '../ui-components/vb-button/vb-button.component';
import { VbButtonGroupComponent } from '../ui-components/vb-button-group/vb-button-group.component';
import { VbSearchInputComponent } from '../ui-components/vb-search-input/vb-search-input.component';
import { VbDialogComponent } from '../ui-components/vb-dialog/vb-dialog.component';
import { DataKeyEditorComponent } from './data-key-editor/data-key-editor.component';
import { NavigationStyleSelectorComponent } from './navigation-style-selector/navigation-style-selector.component';
import { AvatarModule } from 'primeng/avatar';
import { TagModule } from 'primeng/tag';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@NgModule({
  declarations: [
    PropertiesPaneComponent,
    VsExcelComponent,
    PageHeaderComponent,
    CustomReactComponent,
    LayoutComponent,
    UIFilterPipe,
    CheckboxGroupComponent,
    CheckboxComponent,
    IconSelectorComponent,
    RoleLookupComponent,
    PickupListComponent,
    EventEditorComponent,
    FontComponent,
    ColorpickerComponent,
    ConditionalFormatterComponent,
    JsonEditorComponent,
    BtnActionComponent,
    CustomMethodComponent,
    SizeComponent,
    StyleEditorComponent,
    TilepickerComponent,
    MobileLayoutComponent,
    FilteroptionsPipe,
    DynamicOptionsPipe,
    StaticoptionsPipe,
    DynamicDropdownComponent,
    WfMermaidDiagramComponent,
    MailTemplateComponent,
    VsQbBuilderComponent,
    FormulaBuilderComponent,
    FontSelectorComponent,
    RemoveSpacesPipe,
    TableAclComponent,
    VsImportPropComponent,
    VsForeignKeyTblComponent,
    IndexDesignerComponent,
    DropdownWithIndexdesignerComponent,
    TransientFieldMappingComponent,
    DefaultValCompComponent,
    VsExportPropComponent,
    VbTextareaComponent,
    VbInputTextComponent,
    VbInputNumberComponent,
    SearchableCtrlComponent,
    ReferenceTreeViewComponent,
    VbBlockerComponent,
    PreValidationTblViewComponent,
    TblTypeDropdownComponent,
    DecNumberComponent,
    BtnBeforeActionComponent,
    FilterOptionsComponent,
    ConsumerappsSelectComponent,
    LookupDefinitionComponent,
    PgLookupConfigurationComponent,
    QueryMappingComponent,
    QueryTypeComponent,
    RestConsumedAuthenticationTypeDropdownComponent,
    RuntimeConfigComponent,
    RuntimeFieldConfigDialogComponent,
    CudConfigComponent,
    QueryParamMapComponent,
    EditorWithAutocompleteComponent,
    SearchFieldSettingsComponent,
    PageVariablesPropertyComponent,
    SchemaToDataModelComponent,
    DataModelVisualizerComponent,
    SchemaPropertiesPaneComponent,
    SearchFieldSettingsComponent,
    AppLoaderAnimatedComponent,
    DeltaSqlGenerationComponent,
    TimeAgoPipe
  ],
  exports: [
    PropertiesPaneComponent,
    VsExcelComponent,
    PageHeaderComponent,
    CustomReactComponent,
    LayoutComponent,
    UIFilterPipe,
    CheckboxGroupComponent,
    CheckboxComponent,
    PickListModule,
    TooltipModule,
    ChipsModule,
    FontComponent,
    ProgressSpinnerModule,
    OrderListModule,
    DatePickerModule,
    FloatLabelModule,
    MonacoEditorModule,
    FormsModule,
    ReactiveFormsModule,
    InputTextModule,
    CascadeSelectModule,
    FilteroptionsPipe,
    DynamicOptionsPipe,
    StaticoptionsPipe,
    VsQbBuilderComponent,
    WfMermaidDiagramComponent,
    FormulaBuilderComponent,
    RemoveSpacesPipe,
    TimeAgoPipe,
    TabsModule,
    IndexDesignerComponent,
    ToolbarModule,
    DynamicDialogModule,
    TreeTableModule,
    BadgeModule,
    Menu,
    Select,
    VbBlockerComponent,
    ColorpickerComponent,
    CheckboxModule,
    TreeSelectModule,
    ChipModule,
    TreeModule,
    DataModelVisualizerComponent,
    SchemaToDataModelComponent,
    StaticTextComponent,
    ConsoleErrorPanel,
    VbButtonComponent,
    VbButtonGroupComponent,
    VbSearchInputComponent,
    VbDialogComponent,
    ConsoleErrorPanel,
    DataKeyEditorComponent,
    AppLoaderAnimatedComponent,
    TableModule,
    MenuModule,
    DialogModule,
    ConfirmDialogModule,
    MultiSelectModule,
    ButtonModule,
    AvatarModule,
    TagModule,
    SelectModule,
    CheckboxModule,
    TooltipModule
  ],
  imports: [
    CommonModule,
    TranslateModule,
    NgxAngularQueryBuilderModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    SelectModule,
    AccordionModule,
    ColorPickerModule,
    AutoCompleteModule,
    FileUploadModule,
    GridsterModule,
    ButtonModule,
    EditorModule,
    InputNumberModule,
    TextareaModule,
    InputTextModule,
    CheckboxModule,
    SplitButtonModule,
    SplitterModule,
    ProgressBarModule,
    PickListModule,
    TooltipModule,
    MultiSelectModule,
    ChipsModule,
    TableModule,
    PopoverModule,
    ProgressSpinnerModule,
    RadioButtonModule,
    SelectButtonModule,
    OrderListModule,
    DatePickerModule,
    FloatLabelModule,
    MonacoEditorModule,
    CascadeSelectModule,
    MessagesModule,
    DataKeyEditorComponent,
    MessageModule,
    AngularSvgIconModule.forRoot(),
    NgSelectModule,
    TabsModule,
    CustomDirectivesModule,
    ToolbarModule,
    DynamicDialogModule,
    TreeTableModule,
    BadgeModule,
    MenuModule,
    AccordionModule,
    BlockUIModule,
    ConfirmDialogModule,
    TreeSelectModule,
    ChipModule,
    TreeModule,
    CarouselModule,
    ConsoleErrorPanel,
    ViewChangesComponent,
    MergeHistoryComponent,
    StaticTextComponent,
    CreateBranchTagPopupComponent,
    VbButtonComponent,
    VbButtonGroupComponent,
    VbSearchInputComponent,
    VbDialogComponent,
    ProviderEnvUrlConfigComponent,
    NavigationStyleSelectorComponent,
    AvatarModule,
    TagModule,
    ToggleSwitchModule
],
  providers: [DialogService]
})
export class SharedModule {}
